import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {IMail} from './mail.interface';

@Injectable()
export class MailService {
  constructor(private http: HttpClient) {
  }

  list(): Observable<IMail[]> {
    return this.http.get<IMail[]>(`${environment.apiEndpoint}/mail`);
  }

  one(id: number): Observable<IMail> {
    return this.http.get<IMail>(`${environment.apiEndpoint}/mail/${id}`);
  }

  update(id: IMail['id'], body: Partial<IMail>): Observable<IMail> {
    return this.http.patch<IMail>(`${environment.apiEndpoint}/mail/${id}`, body);
  }

  create(body: Partial<IMail>): Observable<IMail> {
    return this.http.post<IMail>(`${environment.apiEndpoint}/mail`, body);
  }

  delete(id: IMail['id']): Observable<any> {
    return this.http.delete(`${environment.apiEndpoint}/mail/${id}`);
  }

}
